import { ManagerAvatarVariantType, ManagerContactLinkType } from '../types'

export const MANAGER_CARD_CONTACT_TYPES: ManagerContactLinkType['type'][] = ['telegram', 'whatsapp', 'email']
export const AVATAR_STATUSES_VARIANTS: Record<ManagerAvatarVariantType, ManagerAvatarVariantType> = {
  BusinessTrip: 'BusinessTrip',
  Offline: 'Offline',
  Online: 'Online',
  SickLeave: 'SickLeave',
  Vacation: 'Vacation',
}
